import { forwardRef } from 'react';
import { css, cx } from '@linaria/atomic';
import { LayoutGroup } from 'motion/react';
import { CarouselBarProps } from '../types';

export const CarouselBar = forwardRef<HTMLDivElement, CarouselBarProps>(
  ({ activeSlide, children, fullWidth, isScrollable, uniqueId, className, ...rest }, ref) => {
    return (
      <div ref={ref} data-role='carousellist' {...rest} className={cx(carouselListStyles, className)}>
        <LayoutGroup id={uniqueId}>{children}</LayoutGroup>
      </div>
    );
  }
);

const carouselListStyles = css`
  width: 100%;
  height: 40px;
  display: flex;
  overflow: auto hidden;
  position: relative;
  scrollbar-width: none;
  scroll-behavior: smooth;
`;

CarouselBar.displayName = 'CarouselBar';
